import React from 'react'
import { observer } from 'mobx-react'
import './styles.scss'
import { i18nTranslate } from 'src/utils'

@observer
class SubscriptionShippingAddressDetail extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { addressDetails = {} } = this.props
    const {
      addressLine1 = '',
      addressLine2 = '',
      city = '',
      state = '',
      county = '',
      country = '',
      zip = '',
    } = addressDetails

    const shippingAddressTitle = i18nTranslate(
      'subscriptionSummaryCard.shippingAddressCaption',
      'Shipping Address',{ isNextGenTranslations: true }
    )

    return (
      <div
        className="subscription-shipping-address-wrapper"
        data-testid="qa-shipping-address-wrapper">
        <span>{shippingAddressTitle}</span>
        <span className="mr-1">:</span>
        <span
          className="shipping-address-details"
          data-testid="qa-shipping-address-line-wrapper">
          {`${addressLine1},${addressLine2 ? ' ' + addressLine2 + ',' : ''}${
            city ? ' ' + city + ',' : ''
          } ${county ? ' ' + county + ',' : ''}${
            state ? ' ' + state + ',' : ''
          } ${zip} ,${country}`}
        </span>
      </div>
    )
  }
}

export default SubscriptionShippingAddressDetail
export { SubscriptionShippingAddressDetail }
